
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('line',{attrs:{"y1":"-0.75","x2":"13","y2":"-0.75","transform":"matrix(3.50167e-09 1 -0.997152 -0.0754228 6.52954 0)","stroke":"#296654","stroke-width":"1.5"}}),_c('line',{attrs:{"y1":"-0.75","x2":"13","y2":"-0.75","transform":"matrix(1 1.53382e-08 0.0754227 0.997152 0.529419 7)","stroke":"#296654","stroke-width":"1.5"}})])
          )
        }
      }
    